import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "reset_password_container" }
const _hoisted_2 = { class: "reset_title" }
const _hoisted_3 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_4 = {
  key: 1,
  class: "errorNotice"
}
const _hoisted_5 = {
  key: 2,
  class: "errorNotice"
}

import { ref, computed } from 'vue';
import InputField from '../inputField.vue';
import { resetPassword as resetPasswordApi } from '@/api/user';
import { useI18n } from 'vue-i18n';
import MainButton from '../../../components/common/mainButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'resetPasswordStep',
  props: {
    uuid: {
        type: String,
        default: ''
    },
    contact: {
        type: String,
        default: ''
    },
    contactType: {
        type: String,
        default: ''
    },
    areaCode: {
        type: String,
        default: ''
    },
    fpUuid: {
        type: String,
        default: ''
    }
},
  emits: ['reset'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const btnLoading = ref(false)
const props = __props;

const emit = __emit;

const newPassword = ref('');
const confirmPassword = ref('');

const resetPassword = () => {
    const params = {
        contact: props.contact,
        contactType: props.contactType,
        areaCode: props.areaCode,
        newPassword: newPassword.value.trim(),
        confirmPassword: confirmPassword.value.trim(),
        fpUuid: props.fpUuid
    };
    btnLoading.value = true;
    resetPasswordApi(params)
        .then(res => {
            if (res.code === 200) {
                showSuccess(res.msg);
                setTimeout(() => {
                    emit('reset');
                }, 500);
            } else {
                showError(res.msg)
            }
            btnLoading.value = false;
        })
        .catch(err => {
            console.error('Reset password error:', err);
            showError(err)
            btnLoading.value = false;
        });
};

const checkPasswordValidation = (value: string) => {
  if (value.length === 0) {
    passwordValidationNotice.value = false
    return
  }

  passwordValidationNotice.value =
    !(value.length >= 8 && value.length <= 20)
}

const checkConfirmPasswordValidation = (value: string) => {
  if (value.length === 0) {
    confirmPasswordValidationNotice.value = false
    return
  }

  confirmPasswordValidationNotice.value =
    !(value.length >= 8 && value.length <= 20)
}

const passwordMismatch = computed(() => {
  return (
    confirmPassword.value.length > 0 &&
    newPassword.value.length > 0 &&
    newPassword.value !== confirmPassword.value
  )
})

const passwordChange = (value: string) => {
  newPassword.value = value
  checkPasswordValidation(value)
  checkConfirmPasswordValidation(confirmPassword.value)
}

const confirmPasswordChange = (value: string) => {
  confirmPassword.value = value
  checkConfirmPasswordValidation(value)
}

const isFormValid = computed(() => {
  return (
    newPassword.value.length >= 8 &&
    newPassword.value.length <= 20 &&
    confirmPassword.value.length >= 8 &&
    confirmPassword.value.length <= 20 &&
    newPassword.value === confirmPassword.value
  )
})

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('common.resetPasswordNow')), 1),
      _createVNode(InputField, {
        modelValue: newPassword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
        isShowError: passwordValidationNotice.value,
        onValueChanged: passwordChange,
        isPassword: true,
        labelText: _ctx.$t('loginRegister.enterPassword'),
        fieldType: "password"
      }, null, 8, ["modelValue", "isShowError", "labelText"]),
      (passwordValidationNotice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_van_icon, { name: "warning-o" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(InputField, {
        modelValue: confirmPassword.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
        isShowError: confirmPasswordValidationNotice.value || passwordMismatch.value,
        onValueChanged: confirmPasswordChange,
        isPassword: true,
        labelText: _ctx.$t('loginRegister.confirmPassword'),
        fieldType: "password"
      }, null, 8, ["modelValue", "isShowError", "labelText"]),
      (confirmPasswordValidationNotice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_van_icon, { name: "warning-o" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1)
          ]))
        : _createCommentVNode("", true),
      (passwordMismatch.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_van_icon, { name: "warning-o" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('loginRegister.differentPassword')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(MainButton, {
        title: _ctx.$t('common.resetPasswordNow'),
        radius: "5px !important",
        activeStatus: isFormValid.value,
        onClick: resetPassword,
        "btn-padding": "30px !important",
        style: {"margin":"2rem 0 1rem"},
        isBtnLoading: btnLoading.value
      }, null, 8, ["title", "activeStatus", "isBtnLoading"])
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})